import { InferType, object, string } from "yup";

export const userGroupInfoSchema = object({
  name: string().required("Group name cannot be blank"),
}).noUnknown();

export type UserGroupInfoSchema = InferType<typeof userGroupInfoSchema>;
